import React from 'react';
import { StreamSectionRenderer } from '../../stream/StreamSectionRenderer';
import { StreamPageSectionFields } from './StreamPageSectionFields';
import {
  STREAM_SECTION_TYPES,
  defaultSection,
  getSectionSummary,
  getSectionTypeMeta,
  streamPagePublicPath,
} from './shared';
import PageVisualEditor from '../pageEditor/PageVisualEditor';

export default function StreamPageVisualEditor({
  previewSchedule = [],
  form,
  setForm,
  ...props
}) {
  return (
    <PageVisualEditor
      {...props}
      form={form}
      setForm={setForm}
      sectionTypes={STREAM_SECTION_TYPES}
      defaultSection={defaultSection}
      getSectionSummary={getSectionSummary}
      getSectionTypeMeta={getSectionTypeMeta}
      SectionFields={StreamPageSectionFields}
      renderSection={(section) => <StreamSectionRenderer section={section} schedule={previewSchedule} />}
      publicPath={props.editingSlug ? streamPagePublicPath(props.editingSlug) : null}
      newTitle="New stream page"
      heroVariant="stream"
      topbarExtra={form.isSystem ? <span className="admin-pill is-muted">System page</span> : null}
      pageExtras={(
        <>
          <label>
            Nav label
            <input value={form.navLabel} onChange={(event) => setForm({ ...form, navLabel: event.target.value })} placeholder="Memes" />
          </label>
          <label className="admin-checkbox">
            <input type="checkbox" checked={form.showInNav} onChange={(event) => setForm({ ...form, showInNav: event.target.checked })} />
            Show in Stream nav dropdown
          </label>
        </>
      )}
    />
  );
}
